import axios from "axios";

export const getAllUsers = async () => {
  let res = await axios.post(`https://infini8ai.herokuapp.com/users`, {
    request: {
      method: "getAllUsers",
    },
  });
  let json = res.data.response.data;
  return json;
};
export const getUsersByCompany = async (userData) => {
  let res = await axios.post(`https://infini8ai.herokuapp.com/users`, {
    request: {
      method: "getUsersByCompany",
      data: userData,
    },
  });

  let json = res.data.response.data;
  return json;
};
export const getCompany = async (userData) => {
  let res = await axios.post(`https://infini8ai.herokuapp.com/company`, {
    request: {
      method: "getCompany",
      data: userData,
    },
  });

  let json = res.data.response.data;
  return json;
};

export const saveNotification = async (userData) => {
  let res = await axios.post(`https://infini8ai.herokuapp.com/notifications`, {
    request: {
      method: "saveNotification",
      data: userData,
    },
  });

  let json = res.data.response.data;
  return json;
};
